var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { useForm } from 'react-hook-form';
import { useFindMachineMutation } from '../../../application/features/machines/machine-api';
import useTranslate from '../../../localization/helpers';
import MachineDocuments from '../MachineDocuments';
import FindByMachine from './FindByMachine';
var FindDocuments = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, machineId = _a.machineId, closePopover = _a.closePopover;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var _b = __read(useState(false), 2), machineDocumentsModalOpen = _b[0], setMachineDocumentsModalOpen = _b[1];
    var _c = __read(useFindMachineMutation(), 2), triggerGetMachine = _c[0], _d = _c[1], machine = _d.data, isMachineLoading = _d.isLoading, isSuccess = _d.isSuccess;
    var showMachineDocuments = machineDocumentsModalOpen && !isMachineLoading && !!machine;
    var _e = useForm({
        defaultValues: {
            serialNumber: '',
            modelNumber: '',
            id: ''
        }
    }), control = _e.control, handleSubmit = _e.handleSubmit, reset = _e.reset, setValue = _e.setValue, watch = _e.watch, errors = _e.formState.errors;
    useEffect(function () {
        if (isSuccess)
            setMachineDocumentsModalOpen(true);
    }, [isSuccess]);
    useEffect(function () {
        if (machineId)
            setValue('id', machineId);
    }, [machineId, setValue]);
    var selectedMachine = watch('id');
    var onSubmit = function (query) {
        triggerGetMachine(query);
    };
    var onClose = function () {
        reset();
        setIsOpen(false);
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: isOpen, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [translate('assets.startChatByAsset'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: onClose, children: _jsx(X, { size: 20, color: theme.palette.action.active }) })] }), _jsx(DialogContent, { dividers: true, children: _jsx(FindByMachine, { control: control, errors: errors, setValue: setValue, selectedMachine: selectedMachine }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, variant: 'outlined', color: 'inherit', disabled: isMachineLoading, children: translate('actions.cancel') }), _jsx(Button, { onClick: handleSubmit(onSubmit), color: 'inherit', variant: 'contained', disabled: isMachineLoading, children: translate('actions.findNow') })] }), showMachineDocuments && (_jsx(MachineDocuments, { machine: machine, isOpen: machineDocumentsModalOpen, setIsOpen: setMachineDocumentsModalOpen, onStartChat: function () { return onClose(); }, closePopover: closePopover }))] }));
};
export default FindDocuments;
